import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';

class AnalyticInventoryOperationService extends EntityApiService<any> {
  getLastUpdated = () =>
    this.handleResponse(ApiClientService.get(this.getPath('/last-update')));

  getOverview = (params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath('/overview'), params, config));

  getProducts = (params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath('/products'), params, config));
}

export default new AnalyticInventoryOperationService(
  '/ms-analytics/api/v1/inventory-operation-analytic',
);
